export const cspMetaContent = `
    default-src 'self' https://js.intercomcdn.com;
    script-src 'self'
      https://www.gstatic.com
      https://www.google.com 
      https://*.googletagmanager.com
      http://connect.facebook.net
      https://www.google-analytics.com 
      https://widget.intercom.io 
      https://js.intercomcdn.com 
      https://app.intercom.io
      'sha256-D6kpIX0A4TTsmvxfEpOpkS2C/u3VGN/Hbjf0UwftoVg=';
    style-src 'self'
        https://www.gstatic.com https://fonts.googleapis.com
        'sha256-47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU='
        'sha256-j9/60v3MiRgPdQJ2b7ZU+DEkfhQr51GB9dPz83DCKe4='
        'sha256-RvAvREUHojDuwHylTVWZp9DhleqLs6ml8G7LpjCF+EY='
        'sha256-jeqF/KOZQUN09P6WureBhg6KaSU3byjxxUBt0mQk5DA=';
    style-src-elem 'self'
         https://fonts.googleapis.com 
         https://www.gstatic.com 
         http://fonts.googleapis.com
         https://maxcdn.bootstrapcdn.com
         https://cdnjs.cloudflare.com
         'sha256-AbpHGcgLb+kRsJGnwFEktk7uzpZOCcBY74+YBdrKVGs='
         'sha256-47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU='
         'sha256-Z5qHS3RiQRERK7Pre41B9RJ4vwm1x671HWQAmyYzzTA='
         'sha256-aRHvpFsBgbKU5FW/QhYmHJh94Go6M6qVymnoBcBimE0='
         'sha256-fRc19zkjeOhuUPdC2vgrnlLLcPitfcwTZ2rgqC17yfM='
         'sha256-69d+dxAoVARIb6Jt7xHhdByzrLpR84AKaHKw8RvutZw='
         'sha256-CYLYoYMF7J09ZB3W6DzacJz9DS3zxt/RC0kIWXF2OVE='
         'sha256-1H6KRo9HCGhaW8k2Dv9L03kfGA/d3taS/IJ8JCzzkbs='
         'sha256-+5C4f1XbmCbzXsdr7K/mEuwD9mIxPne5DPG8qjhlfEw='
         'sha256-eyqX4oKRZ6w0srtRFWgJfjq+YZXAshpHMAfC51QeoeM='
         'sha256-YI4HPAdfnmYHeGs8XCj45dClLpZnJdxxvtbRbvXt7Is='
         'sha256-sK0kdcsXspH+X9s+VqOvdFCs3/4XRBNkhmGTGZ1DLnc='
         'sha256-OkAb7bKXzrjh4ezbLAC41bDg3r4wAxNZ3+CA2G+hvUU=' 
         'sha256-NGHMC5GVeMgXXABZsJc4IvW5xS3tpmHNJqo3tQVjlRw=' 
         'sha256-j+FuuGaAY3Pgq+EmOMmUv/wzFBwsoNFRyoFee7NOLqM=' 
         'sha256-nUVB55d4xwiacyDeeks1zaWRgvVTbvMA9frvqFi6cFc=' 
         'sha256-C9EGeLwsmcZE3NdL7zxiOprypCM8gyVzzT5rMGJyF8k='
         'sha256-qVDV/HkjlzpDFdywp2Q9OX/lMsAZxi1at/+fjli1ilE='
         'sha256-1zyvmAtNHFYh/e7PME4Sb128yQc+sSLc8fanwmP/CHs='
         'sha256-8+kKIG5oQOz9oO/P8TY438GNf6H6Utb1chVdYmn7acw=' 
         'sha256-uHW4RiPtxi/z1eZC3N7fbFx7QJZT0VfQyBeorw9jyPw='
         'sha256-cZskZuSnPo4zF9SjzJADqHeYHUtJ64pgGV2MMy/93cc='
         'sha256-NzY0ULFCP7+nP0CcT0IfV6wlbpJJdP8ZT7QgDhOxmvk='
         'sha256-sBQsWMquRRh0OFYe+ePjct5C0fNb7BnVpTDgJYeuHD4='
         'sha256-Gd33fYBGq1zOWIx+Et2idGH3Ns4jvDacbkZVDUdg7jA='
         'sha256-rwUAyPfPT65UhixPtz4s5OIlfcqmT+iPAAz8hoSvcsc='
         'sha256-Ws/+QebsrCTNI3/EhPv38N4ZLpgufgsmbnODy56dWVU='
         'sha256-nal3vikEsoQWk+Y5R8X5Vka+0rKm/yKXVieBli6ZCjI='
         'sha256-pbG/fxIietwND2Bs7838fZt5PmlHPOB9NiPNdBMi7dA='
         'sha256-7rCmboZ3fD/QKTnoi7M/Xk/SqXJEkHsxl9HMjQiNrHA='
         'sha256-uVNO+V0KU6txWZxuGUsElazlrWUVG5Wk7KtfWfOHncw='
         'sha256-IyegZdLjxkVgzdwLkJ0BJ33ot0O30lmRQ31ZM9JAiiM='
         'sha256-61nJJRC4T2H5bPhKMojqDqX/qjCHkR0/01/HIDEwzGw='
         'sha256-hao4jpln3GepRQAhzXlNyIU5EdISqQCPuEPVpV3EyI8='
         'sha256-zeC3RZVkg6n1JfEWwEdsF+q04ONKcnc1f6Vmr524qYo='
         'sha256-pvSoUTO+lA4i6IXfK165B+QjVaud7QyhbbT/isLt8Iw='
         'sha256-0HMtDSvec7Pb1PLD/zPO4+gHi3V1DRKY6uitoN//WHs='
         'sha256-/UNHtEMEEqXRycD3w7yWnrxQkCe0w4uaJ1NH1UepNzI='
         'sha256-UExwlob+4TWVptWjkFrYsHnHQR5olOxNNZb6F7jcWsM='
         'sha256-bKotKRuviNw/Sxqu0ZUpdfSeJ6XtQO1K5yNwA3VOmjY='
         'sha256-lIBmVrO4GuQPoKLyObdQFZt8wu5sBZpbLF2rhcjmEX4='
         'sha256-01INOfGgb0+P6huIns1eJHGsw1ibHQrfy7jXlKGFJlA='
         'sha256-CV5tkBm9NPgyHzEykleRK2/qO6mS49N+B6UBLTdbs9Y='
         'sha256-st5i4Kh4wePE7OYye1kklPe+Y5FbtRSMkoLSAn3XNrU='
         'sha256-0wFoxLWTA6T27YIInZDAw8Oiuey8EYEvoep1vDAGSdE='
         'sha256-G1vQFLsS54Fw4zjWx9e4r2DbVVb2xfvo9DY5Pl+fI9M='
         'sha256-kibHPItXqmCxKQaikL8yLE4EvXoCs/ajFr+bdXUqZPM='
         'sha256-QX+kbJf8GwfgDjCI/97NNm00LB9Lr+89TmtzPdPkPuA='
         'sha256-+VEcjrbmZCV0tsnA2JV9Y8u+zk3/BB70wyR/ZyqAIUY='; 
    img-src 'self' blob data: https:
         https://web.facebook.com
         https://connect.facebook.net 
         https://chatdesk-assets.s3.amazonaws.com 
         https://www.google.com 
         https://www.google.com.ng 
         https://*.google-analytics.com 
         https://*.analytics.google.com
         https://*.googletagmanager.com
         https://s3.amazonaws.com
         https://heapanalytics.com
         https://js.intercomcdn.com
         https://static.intercomassets.com
         https://downloads.intercomcdn.com
         https://downloads.intercomcdn.eu
         https://downloads.au.intercomcdn.com
         https://uploads.intercomusercontent.com
         https://gifs.intercomcdn.com 
         https://video-messages.intercomcdn.com
         https://messenger-apps.intercom.io
         https://messenger-apps.eu.intercom.io
         https://messenger-apps.au.intercom.io
         https://*.intercom-attachments-1.com
         https://*.intercom-attachments.eu
         https://*.au.intercom-attachments.com
         https://*.intercom-attachments-2.com
         https://*.intercom-attachments-3.com
         https://*.intercom-attachments-4.com
         https://*.intercom-attachments-5.com
         https://*.intercom-attachments-6.com
         https://*.intercom-attachments-7.com
         https://*.intercom-attachments-8.com
         https://*.intercom-attachments-9.com
         https://static.intercomassets.eu
         https://static.au.intercomassets.com;
    frame-src 'self' 
        https://chatdesk-development.us.auth0.com 
        https://chatdesk-staging.us.auth0.com 
        https://auth.chatdesk.com 
        https://chatdesk.com 
        https://www.youtube.com 
        https://www.tiktok.com
        https://www.loom.com
        http://www.under510.com
        https://intercom-sheets.com;
    connect-src 'self'
         https://firebase.googleapis.com
         https://firebaseinstallations.googleapis.com
         https://chatdesk-development.us.auth0.com
         https://*.google-analytics.com
         https://*.analytics.google.com
         https://analytics.google.com
         https://*.googletagmanager.com
         http://localhost:8080
         http://localhost:8081
         http://localhost:8090
         https://cdn.heapanalytics.com
         https://teamsapi.chatdesk.com
         https://trends.chatdesk.com
         https://teamsdevapi.chatdesk.com
         https://awstrendsdev.chatdesk.com
         https://websocketdev.chatdesk.com
         https://websocket.chatdesk.com
         https://teamsstagingapi.chatdesk.com
         https://trendsstaging.chatdesk.com
         https://websocketstaging.chatdesk.com
         https://stats.g.doubleclick.net
         https://web.facebook.com
         https://connect.facebook.net
         https://www.facebook.com
         https://graph.facebook.com
         https://o984787.ingest.us.sentry.io
         https://chatdesk-staging.us.auth0.com
         https://auth.chatdesk.com
         https://chatdesk-development.us.auth0.com
         https://chatdesk.com
         wss://websocketdev.chatdesk.com 
         wss://websocket.chatdesk.com 
         wss://websocketstaging.chatdesk.com
         https://cdnjs.cloudflare.com
         https://maxcdn.bootstrapcdn.com
         https://via.intercom.io
         https://api.intercom.io
         https://api.au.intercom.io
         https://api.eu.intercom.io
         https://api-iam.intercom.io
         https://api-iam.eu.intercom.io
         https://api-iam.au.intercom.io 
         https://api-ping.intercom.io
         https://*.intercom-messenger.com
         wss://*.intercom-messenger.com
         https://nexus-websocket-a.intercom.io
         wss://nexus-websocket-a.intercom.io
         https://nexus-websocket-b.intercom.io
         wss://nexus-websocket-b.intercom.io
         https://nexus-europe-websocket.intercom.io 
         wss://nexus-europe-websocket.intercom.io 
         https://nexus-australia-websocket.intercom.io
         wss://nexus-australia-websocket.intercom.io 
         https://uploads.intercomcdn.com
         https://uploads.intercomcdn.eu 
         https://uploads.au.intercomcdn.com 
         https://uploads.eu.intercomcdn.com
         https://uploads.intercomusercontent.com;
    font-src 'self'
         https://fonts.gstatic.com
         https://maxcdn.bootstrapcdn.com
         https://fonts.intercomcdn.com
         https://js.intercomcdn.com
`;
